module.exports = __webpack_public_path__ + "img/rz_01.7cb7a2d3.png";